import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Avatar from 'components/Utils/Avatar'
import IconButton from 'components/Utils/IconButton'

import {
  rolesMap as userRolesMap,
  rolesMapPluralized as groupRolesMap,
  defaultRolesMapFree,
  defaultRolesMapPaid,
} from 'remote/channels/roles'
import {
  getOrganizationId,
  getOrganization,
} from 'data/organizations/selectors'

import { DeleteIcon } from 'components/Utils/Icons'
import SelectRole from 'components/Utils/SelectRole'
import UserRow from 'components/Users/UserRow'
import UserGroupRow from 'components/UserGroups/UserGroupRow'

class ChannelMembershipList extends PureComponent {
  static propTypes = {
    canManage: PropTypes.bool.isRequired,
    defaultRole: PropTypes.string.isRequired,
    onDefaultRoleChange: PropTypes.func,
    showDefaultRole: PropTypes.bool,
    isPaid: PropTypes.bool,
    usersMemberships: PropTypes.arrayOf(
      PropTypes.shape({
        user: PropTypes.object.isRequired,
        role: PropTypes.string.isRequired,
      })
    ).isRequired,
    updateUserRole: PropTypes.func.isRequired,

    userGroupsMemberships: PropTypes.arrayOf(
      PropTypes.shape({
        userGroup: PropTypes.object.isRequired,
        role: PropTypes.string.isRequired,
      })
    ).isRequired,
    updateUserGroupRole: PropTypes.func.isRequired,
  }

  render() {
    const {
      isPaid,
      canManage,
      showDefaultRole,
      defaultRole,
      onDefaultRoleChange,
      organization,
    } = this.props
    const defaultRolesMap = isPaid ? defaultRolesMapPaid : defaultRolesMapFree

    return (
      <React.Fragment>
        {showDefaultRole && (
          <MembershipRowLayout
            canManage={canManage}
            role={defaultRole}
            rolesMap={defaultRolesMap}
            setRole={onDefaultRoleChange}
          >
            <div className="flexbox flexbox-align-center">
              <Avatar
                borderClass="border-none"
                size="small"
                name={organization.name}
                url={organization.photoURL}
              />
              <div className="margin-left-normal margin-right-smaller font-weight-bold shade-05">
                Everyone at {organization.name}
              </div>
            </div>
          </MembershipRowLayout>
        )}

        {this.props.userGroupsMemberships.map(({ userGroup, role }) => {
          return (
            <UserGroupMembershipRow
              key={userGroup.id}
              canManage={this.props.canManage}
              userGroup={userGroup}
              role={role}
              updateUserGroupRole={role =>
                this.props.updateUserGroupRole({ userGroup, role })
              }
            />
          )
        })}

        {this.props.usersMemberships.map(({ user, role }) => {
          return (
            <UserMembershipRow
              canManage={this.props.canManage}
              key={user.id}
              user={user}
              role={role}
              updateUserRole={role => this.props.updateUserRole({ user, role })}
              userRolesMap={userRolesMap}
            />
          )
        })}
      </React.Fragment>
    )
  }
}

function MembershipRowLayout({
  children,
  role,
  setRole = role => {},
  rolesMap = userRolesMap,
  onRemove = null,
  canManage,
  isPaid,
}) {
  return (
    <div className="flexbox flexbox-align-center margin-bottom-normal full-width">
      <div className="flexbox-grow">{children}</div>

      <SelectRole
        onSelectRole={setRole}
        currentRole={role}
        roles={rolesMap}
        align="end"
        disabled={!canManage}
        isPaid={isPaid}
      />
      <div
        style={{ width: 32 }}
        className="flexbox flexbox-justify-end margin-left-small"
      >
        {canManage &&
          onRemove && (
            <IconButton onClick={onRemove}>
              <DeleteIcon className="shade-20 pointer" />
            </IconButton>
          )}
      </div>
    </div>
  )
}

function UserMembershipRow({
  canManage,
  user,
  role,
  updateUserRole,
  userRolesMap,
}) {
  return (
    <MembershipRowLayout
      canManage={canManage}
      role={role}
      setRole={updateUserRole}
      onRemove={() => updateUserRole('none')}
      rolesMap={userRolesMap}
    >
      <UserRow user={user} />
    </MembershipRowLayout>
  )
}

function UserGroupMembershipRow({
  canManage,
  userGroup,
  role,
  updateUserGroupRole,
}) {
  return (
    <MembershipRowLayout
      canManage={canManage}
      role={role}
      setRole={updateUserGroupRole}
      onRemove={() => updateUserGroupRole('none')}
      rolesMap={groupRolesMap}
    >
      <UserGroupRow userGroup={userGroup} />
    </MembershipRowLayout>
  )
}

export default connect(state => {
  const organizationId = getOrganizationId(state)
  const organization = getOrganization(state, organizationId)
  const isPaid = organization.product !== 'free'
  return {
    isPaid,
    organization,
  }
})(ChannelMembershipList)
